// redux/features/loginRecordSlice.ts
import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import api from '@/axiosSetup';
import { ILoginRecord } from '../../../types/ILoginRecord';

interface LoginRecordState {
  records: ILoginRecord[];
  loading: boolean;
  error: string | null;
}

const initialState: LoginRecordState = {
  records: [],
  loading: false,
  error: null,
};

const loginRecordSlice = createSlice({
  name: 'loginRecords',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchLoginRecords.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchLoginRecords.fulfilled, (state, action: PayloadAction<ILoginRecord[]>) => {
        state.records = action.payload;
        state.loading = false;
      })
      .addCase(fetchLoginRecords.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export const fetchLoginRecords = createAsyncThunk(
  'loginRecords/fetchAll',
  async (_, { rejectWithValue }) => {
    try {
      const res = await api.get<ILoginRecord[]>('/api/login-records');
      return res.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch login records');
    }
  }
);

export default loginRecordSlice.reducer;
